/* tslint:disable:max-line-length */
import { PageBillingType } from '@mm/state/interfaces/connected-page';
import { OldToNewRolesMap } from '@mm/state/model/CompanyUsersModel';
import classNames from 'classnames';
import { invert } from 'lodash';
import React from 'react';
import PrimarySelect, { DropdownOption } from '../PrimarySelect/PrimarySelect';
import { RequiredPlanBadge } from '../ProBadge';
import './UserRoleSelector.pcss';

type OuterProps = {
  className?: string;
  onUpdate: (value: string) => void;
  value: string;
  placeholder?: string;
  showTeamBagde?: boolean;
};

type Props = OuterProps;

const rolesArr = [
  'Editor',
  'Company Editor',
  'Live Chat Agent',
  'Company Admin',
];

const rolesWithBadgesMap: { [key: string]: boolean } = {
  Admin: true,
  Collaborator: true,
  'Company Admin': true,
  'Company Editor': true,
};

const UserIcon = () => (
  <svg width="16" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.598 6.5c1.767 0 3.2-1.455 3.2-3.25S7.364 0 5.597 0C3.833 0 2.4 1.455 2.4 3.25S3.833 6.5 5.598 6.5zm0-5.688c1.322 0 2.4 1.095 2.4 2.438 0 1.343-1.078 2.438-2.4 2.438-1.323 0-2.4-1.095-2.4-2.438C3.2 1.907 4.274.812 5.598.812zm10.167 8.45L13.51 6.97a1.587 1.587 0 00-1.13-.475h-1.982c-.443 0-.8.363-.8.812v2.014c0 .432.167.845.467 1.15l2.255 2.293c.155.157.36.239.565.239.205 0 .41-.08.565-.24l2.313-2.348a.823.823 0 00.002-1.152zm-2.878 2.925l-2.255-2.292a.817.817 0 01-.234-.574V7.307h1.982c.212 0 .415.084.565.24L15.2 9.838l-2.313 2.348zm-1.29-4.062c-.22 0-.4.183-.4.406 0 .224.18.406.4.406.22 0 .4-.182.4-.406a.404.404 0 00-.4-.406zm-1.6 4.063H1.2c-.22 0-.4-.183-.4-.407v-1.056c0-1.435 1.147-2.6 2.56-2.6.49 0 .978.406 2.24.406 1.258 0 1.75-.406 2.24-.406.34 0 .662.071.96.193V7.47a3.252 3.252 0 00-.96-.157c-.718 0-1.063.406-2.24.406-1.177 0-1.52-.407-2.24-.407C1.505 7.313 0 8.841 0 10.726v1.056A1.21 1.21 0 001.2 13h8.798c.39 0 .732-.193.952-.485l-.58-.589a.403.403 0 01-.372.261z"
      fill="#525252"
    />
  </svg>
);

const customOptionRenderer = (option: DropdownOption) => {
  return (
    <div>
      <span>{option.name}</span>
      {option.showTeamBagde && (
        <RequiredPlanBadge
          billingType={PageBillingType.TeamLabel}
          className="user-role-selector__badge"
        />
      )}
    </div>
  );
};

export const UserRoleSelector = ({
  className,
  value,
  onUpdate,
  placeholder,
  showTeamBagde,
}: Props) => {
  const rolesObjArr = rolesArr.map((r, i) => ({
    id: i,
    name: r,
    showTeamBagde: rolesWithBadgesMap[r] && showTeamBagde,
  }));
  const NewToOLdRolesMap = invert(OldToNewRolesMap);
  const displayValue = NewToOLdRolesMap[value]
    ? NewToOLdRolesMap[value]
    : value;
  return (
    <div className={classNames('user-role-selector', className)}>
      <div className="user-role-selector__selector-container">
        <span className="user-role-selector__icon">
          <UserIcon />
        </span>
        <PrimarySelect
          className="user-role-selector__selector"
          placeholder={placeholder}
          onChange={({ id }) => {
            const newItem = rolesObjArr.find(r => r.id === id);
            if (newItem) {
              onUpdate(OldToNewRolesMap[newItem.name]);
            }
          }}
          value={rolesObjArr.find(r => r.name === displayValue)}
          options={rolesObjArr}
          customOptionRenderer={customOptionRenderer}
          customDropdownStyles={{ zIndex: '99999999' }}
        />
      </div>
    </div>
  );
};
